'use client'
import ErrorComponent from '@/components/errorComponent'

export default function NotFoundPage() {
  return <ErrorComponent />
}
